import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {FilterBarContainer, SelectContainer, Subscribe, WhiteSpace,} from './FilterBar.styled'
import FooterModal from '../FooterModal/FooterModal'
import {StyledSelect} from '../FilterJobs/FilterJobs.styled'
import useMediaQuery from '../../hooks/useMediaQuery'
import {deviceMax} from '../../theme/breakpoints'
import ButtonVariantEnum from "../../enums/ButtonVariant";

const CATEGORIES_PLACEHOLDER = 'News Category : '
const YEARS_PLACEHOLDER = 'Years : '
const SUBSCRIBE = 'Subscribe to Constellium alerts'

const FilterBar = ({list, parameters, setParameters}) => {
  const [show, setShow] = useState(false)

  const isMobile = useMediaQuery(deviceMax.mobileL)

  const Categories = [
    ...new Set(
      list.flatMap((el) => el.node.categories.map((category) => category.name))
    ),
  ]
  const CategoriesOptions = Categories.map((cat) => {
    return {value: cat, label: cat}
  })

  const Years = [
    ...new Set(list.flatMap((el) => new Date(el.node.date).getFullYear())),
  ]

  const YearsOptions = Years.map((year) => {
    return {value: year, label: year}
  })

  const onChangeFilter = (e, type) => {
    let _filteredCategories = []
    let _filteredYears = []

    if (type === 'category') {
      _filteredCategories = e.select.map((el) => el.value)
      setParameters({
        ...parameters,
        page: 1,
        cat: e.select.map((el) => el.value),
      })
    } else {
      _filteredYears = e.select.map((el) => el.value)
      setParameters({
        ...parameters,
        page: 1,
        years: e.select.map((el) => el.value),
      })
    }
  }

  return (
    <WhiteSpace>
      {/* Modal for mailJet Alerts */}
      <FooterModal
        show={show}
        isMobile={isMobile}
        onClose={() => {
          setShow(false)
        }}
      />
      <FilterBarContainer>
        <SelectContainer>
          <StyledSelect
            onChange={(e) => {
              onChangeFilter(e, 'category')
            }}
            isMulti={true}
            options={CategoriesOptions}
            placeholder={CATEGORIES_PLACEHOLDER}
            value={parameters.cat.map((category) => ({
              value: category,
              label: category,
            }))}
          />
          <StyledSelect
            onChange={(e) => {
              onChangeFilter(e, 'year')
            }}
            isMulti={true}
            options={YearsOptions}
            placeholder={YEARS_PLACEHOLDER}
            value={parameters.years.map((year) => ({
              value: year,
              label: year,
            }))}
          />
        </SelectContainer>
        <Subscribe
          onClick={() => setShow(true)}
          label={SUBSCRIBE}
          variant={ButtonVariantEnum.secondary}
        />
      </FilterBarContainer>
    </WhiteSpace>
  )
}

FilterBar.propTypes = {
  list: PropTypes.array.isRequired,
}

export default FilterBar
